import React, {
    useEffect,
    useState,
    useMemo
} from 'react';
import { useQuery } from '@tanstack/react-query';
import "webcomponent-qr-code";

import * as OPTIONS from "../option-fields";
import * as UTILS from "../utils";
import * as QUERIES from "../query-functions";

import LoadingIndicator from '../components/loading-indicator';
import AccountNavigation from './account-navigation';
import UpsellBlock from '../components/upsell-block';
import LogoutButton from '../components/logout-button';

const AccountTickets = () => {

    const [upcomingTickets, setUpcomingTickets] = useState(null);

    const { 
        isPending: ordersPending,
        data: ordersData,
    } = useQuery({
        queryKey: ['ordersData'],
        queryFn: QUERIES.getOrders,
        refetchOnWindowFocus: false,
        retry: false
    });

    useEffect(() => {
        if (!ordersData) return;

        const upcoming = UTILS.getUpcomingTickets(ordersData);
        setUpcomingTickets(upcoming);

    }, [ordersData]);

    if (ordersPending) return <LoadingIndicator type="page" />

    return (
        <>
            <AccountNavigation />

            <div className='booking-pathway__container booking-pathway__account booking-pathway__account--tickets'>

                <div className='booking-pathway__main-content'>
                    <h1 className='booking-pathway__header'>Tickets</h1>

                    <div className='printable-ticket__list grid'>
                        {upcomingTickets?.map((ticket) => 
                            <PrintableTicket key={ticket.id} ticket={ticket} />
                        )}
                    </div>
                </div>

                <div className='booking-pathway__footer'>
                    <LogoutButton />

                    <UpsellBlock content={OPTIONS.account.orders_upsell} type="orders-upsell" />
                </div>

            </div>
        </>
    );
};

const PrintableTicket = (props) => {
    const formattedDate = useMemo(() => {
        return UTILS.formatDateTime(props.ticket.instance?.start, true)
    }, [props.ticket.instance?.start]);
    
    const { 
        isPending,
        isFetching,
        data: imageData,
    } = useQuery({
        queryKey: ['imageData', props.ticket.event.id],
        queryFn: () => QUERIES.getEventImage(props.ticket.event.id),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000
    });
    
    return (
        <div className='ticket-border'>
            <article className='printable-ticket'>
                <header className='printable-ticket__header'>
                    <div className='printable-ticket__image'>
                        {isPending || isFetching ?
                            <LoadingIndicator />
                        : imageData ?
                            <div dangerouslySetInnerHTML={{__html: imageData}}></div>
                        : 
                            <Logo />
                        }
                    </div>
                    <div className='printable-ticket__qr-code'>
                        <p className='sr-text'>QR Code</p>
                        <qr-code
                            data={ props.ticket.barcode }
                            format="svg"
                            margin="0"
                            modulesize="0"
                        />
                    </div>

                    <h2 className='printable-ticket__title'>{props.ticket.event.name}</h2>
                </header>

                <div className='printable-ticket__content'>
                    {formattedDate ?
                        <time className='printable-ticket__info printable-ticket__info--date' dateTime={props.ticket.instance.start}>
                            <span>{formattedDate.date}</span>
                            <span>{formattedDate.time}</span>
                        </time>
                    :null}
                    <p className='printable-ticket__info printable-ticket__info--price'>
                        <span>{props.ticket.ticketType?.name}</span>
                        <span className='printable-ticket__info--price--total'>£{props.ticket.total?.toFixed(2)}</span>
                    </p>
                    <p className='printable-ticket__info'>
                        <span>Order No.</span>
                        <span>{props.ticket.orderId}</span>
                    </p>
                </div>

                <footer className='printable-ticket__footer'>
                    <p className='printable-ticket__seat-info'>
                        <span className="sr-text">Seat info:</span>
                        {props.ticket.seat?.attribute_Level ?
                            <span>{props.ticket.seat.attribute_Level}</span>
                        :null}
                        <span>{props.ticket.planName}</span>
                        <span>{props.ticket.seat?.name}</span>
                    </p>
                </footer>
            </article>
        </div>
    )
}

export default AccountTickets;
